import { render, staticRenderFns } from "./applicant-preview-modal-link.vue?vue&type=template&id=2aba1cc9"
import script from "./applicant-preview-modal-link.vue?vue&type=script&lang=js"
export * from "./applicant-preview-modal-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports